import './navigation.css'
import { useStore } from "../state/state.ts";
import { clsx, inputOnKeyUp } from "../functions.ts";
import { type StepDescription } from "../state/types.ts";
import { MAIN_PROPERTIES } from "../state/properties.ts";
import TabLink from './tab-link.tsx';

export default function Navigation(props: {steps: Array<StepDescription>, validation: ()=>boolean}) {
  // @ts-ignore:TS6133
  //const _properties = useStore((state)=>state.properties);
  const _properties = MAIN_PROPERTIES.reduce((acc, p)=>{
      acc[p.key] = useStore((state)=>state[p.key]);
      return acc;
  },{});  //MUST EXIST FOR REACTIVITY TO WORK
  const current_step_number = useStore((state) => state.current_step_number);
  const current_step = useStore((state) => state.current_step);
  const increment_step = useStore((state) => state.increment_step);
  const decrement_step = useStore((state) => state.decrement_step);
  const is_last_step = useStore((state) => state.is_last_step);
  const reset = useStore((state) => state.reset);

  return (
    <div className="navigation">
      <div className="navigation__buttons_left">
        <NavigationButtonOutline id="new-button" tabIndex={0} hidden={current_step_number == 0} label="neu" onClick={()=>{reset()}}/>
        <NavigationButtonOutline tabIndex={0} hidden={current_step_number == 0} disabled={current_step_number == 0} label="zurück" onClick={()=>{decrement_step()}}/>
      </div>

      <div className="navigation__steps">
        {props.steps.map( (step: StepDescription, index: number) => 
        <NavigationStep key={step.id} active={current_step_number == index} number={index + 1} label={step.label}/>
        )}
      </div>
      <div className="navigation__buttons_right">
        <TabLink jump_to_id="start-of-view"/>
        <TabLink jump_to_id="start-of-view" last_element/>
        <NavigationButton id="next-button" tabIndex={0} hidden={is_last_step()} disabled={!props.validation()} label="weiter" onClick={()=>{increment_step()}}/>
        <TabLink jump_to_id="new-button"/>
      </div>
    </div>);
}


export function NavigationButton(props: {id?:string, tabIndex: number, label: string, hidden:boolean, disabled: boolean, onClick: () => void}) {
  const onClick = ()=>{if (props.disabled){return;}; props.onClick();}
  return <button 
    id = {props.id}
    tabIndex={props.hidden ? -1 : props.tabIndex}
    inert={props.hidden}
    role="button"
    aria-label={props.label}
    className={clsx("navigation__button", props.disabled && "navigation__button--disabled", props.hidden && "navigation__button--hidden")} 
    onClick={onClick}
    onKeyUp={(event)=>inputOnKeyUp(event, onClick)}
  >{props.label}</button>;
}

export function NavigationButtonOutline(props: {id?:string, tabIndex: number, label: string, hidden:boolean, disabled: boolean, onClick: () => void}) {
  const onClick = ()=>{if (props.disabled){return;}; props.onClick();}
  return <button 
    id = {props.id}
    tabIndex={props.hidden ? -1 : props.tabIndex}
    aria-hidden={props.hidden}
    aria-disabled={props.disabled}
    inert={props.hidden}
    aria-label={props.label}
    className={clsx("navigation__button navigation__button--outline", props.disabled && "navigation__button--disabled", props.hidden && "navigation__button--hidden")} 
    onClick={onClick}
    onKeyUp={(event)=>inputOnKeyUp(event, onClick)}>
      {props.label}
  </button>;
}


export function NavigationStep(props: {active: boolean, label: string, number: number}) {
  const set_step = useStore((state) => state.set_step);
  const current_step_number = useStore((state) => state.current_step_number);

  const done = current_step_number > (props.number - 1);
  const interactive = current_step_number > (props.number - 2);
  const onClick = interactive ? () => {set_step((props.number - 1))} : ()=>{};
  return (
    <button  
      tabIndex={interactive ? 0 : -1}
      disabled={!interactive}
      aria-label={props.number + ' ' + props.label + ((interactive && !done) ? " (ausgewählt)" : (done ? " (abgeschlossen)" : ""))} 
      className={clsx("navigation__step", props.active && "navigation__step--active", interactive ? "navigation__step--interactive" : "navigation__step--disabled")} 
      onClick={onClick}
    >
      <span role="presentation" className="navigation__step-number">{props.number}</span>
      <span role="presentation" className="navigation__step-label">{props.label}</span>
    </button>
  );
}
